import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ChevronLeftIcon, SearchIcon } from 'lucide-react';
import { SuperfoodsTabs } from '../components/SuperfoodsTabs';
export const SuperfoodsInfoPage: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen relative bg-black text-white pt-16 md:pt-20 overflow-hidden" data-id="element-1854">
      {/* Gradient background overlay - reduced opacity for more subtle effect */}
      <div className="absolute inset-0 bg-gradient-to-t from-green-900/40 via-green-900/20 to-black pointer-events-none z-0" data-id="element-1855"></div>
      {/* Decorative elements with reduced opacity */}
      <div className="absolute -bottom-20 -left-20 w-64 h-64 bg-green-500/3 rounded-full filter blur-3xl" data-id="element-1856"></div>
      <div className="absolute -bottom-10 right-10 w-64 h-64 bg-green-500/5 rounded-full filter blur-3xl" data-id="element-1857"></div>
      <div className="absolute top-1/2 left-1/4 w-40 h-40 bg-green-500/3 rounded-full filter blur-3xl" data-id="element-1858"></div>
      <div className="container mx-auto px-4 py-6 relative z-10" data-id="element-1859">
        <div className="flex items-center mb-8" data-id="element-1860"></div>
        <motion.h1 initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-black text-center mb-4" data-id="element-1861">
          Vše, co potřebujete vědět o{' '}
          <span className="text-green-500" data-id="element-1862">superpotravinách</span>
        </motion.h1>
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="w-24 h-1 bg-gradient-to-r from-green-500/40 via-green-500/70 to-green-500/40 mx-auto rounded-full mb-8" data-id="element-1863" />
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-center text-gray-300 max-w-2xl mx-auto mb-10" data-id="element-1864">
          Kompletní průvodce zelenými superpotravinami - vše od účinků a
          dávkování po detoxikaci, nemoci a kvalitu produktů. Vyberte kategorii
          nebo vyhledávejte ve všech informacích.
        </motion.p>
        <div className="relative max-w-xl mx-auto mb-10" data-id="element-1865">
          <input type="text" placeholder="Hledejte v otázkách a odpovědích..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full bg-gray-800 border border-gray-700 rounded-full px-5 py-3 pl-12 text-white focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" data-id="element-1866" />
          <SearchIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" data-id="element-1867" />
        </div>
        <SuperfoodsTabs searchQuery={searchQuery} data-id="element-1868" />
      </div>
    </div>;
};